import {
  fetch,
  getGlobalDispatcher,
  setGlobalDispatcher,
  Dispatcher,
  ProxyAgent,
} from 'undici'

import { URL } from 'node:url'

function getProxyAgent(variableName: string) {
  const proxyURI = process.env[variableName]
  return proxyURI ? new ProxyAgent(proxyURI) : null
}

const httpProxy =
  getProxyAgent('http_proxy_license_server') || getProxyAgent('http_proxy')
const httpsProxy =
  getProxyAgent('https_proxy_license_server') || getProxyAgent('https_proxy')

const proxyAgents = {
  ...(httpProxy ? { 'http:': httpProxy } : {}),
  ...(httpsProxy ? { 'https:': httpsProxy } : {}),
}

const noProxyRules = (process.env['no_proxy'] ?? '')
  .split(',')
  .map((rule) => rule.trim())

const defaultDispatcher = getGlobalDispatcher()

setGlobalDispatcher(
  new (class extends Dispatcher {
    dispatch(options: any, handler: any) {
      if (options.origin) {
        const { host, protocol } =
          typeof options.origin === 'string'
            ? new URL(options.origin)
            : options.origin
        if (
          !noProxyRules.some((rule) =>
            rule.startsWith('.') ? host.endsWith(rule) : host === rule
          )
        ) {
          const proxyAgent = proxyAgents[protocol as 'http:' | 'https:']
          if (proxyAgent) {
            proxyAgent.dispatch(options, handler)
          }
        }
      }
      return defaultDispatcher.dispatch(options, handler)
    }
  })()
)

export async function postRequest<T>(
  url: string,
  data: {},
  options: {
    timeoutInMs?: number
  } = {}
) {
  const controller = new AbortController()

  const timeout = setTimeout(() => {
    controller.abort()
  }, options.timeoutInMs ?? 30000)

  try {
    const response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
    })

    const responseJson = await response.json()

    return {
      status: response.status,
      data: responseJson as T,
    }
  } catch (err) {
    throw new Error('Connection Error', { cause: err })
  } finally {
    clearTimeout(timeout)
  }
}

export default {
  postRequest,
}
